import { cn } from '@/true-fsd/shared/utils/css'
import { isWebKit } from '../../utils/browserDetection'

/**
 * Пропсы для иконки палитры подложки
 */
export interface BackgroundPaletteIconProps {
    /**
     * Дополнительные CSS классы
     */
    className?: string
}

/**
 * WebKit-версия иконки палитры (без foreignObject в SVG)
 * Использует CSS conic-gradient напрямую на div элементе
 * Safari поддерживает conic-gradient в CSS, проблема была только в foreignObject внутри SVG
 */
function BackgroundPaletteIconWebKit({
    className,
}: BackgroundPaletteIconProps) {
    return (
        <div
            className={cn(className)}
            aria-hidden="true"
            style={{
                position: 'relative',
                width: '24px',
                height: '24px',
                flexShrink: 0,
            }}
        >
            {/* Радужный фон с conic-gradient */}
            <div
                style={{
                    position: 'absolute',
                    top: '2px',
                    left: '2px',
                    width: '20px',
                    height: '20px',
                    borderRadius: '4px',
                    background: 'conic-gradient(from 90deg, rgba(199, 70, 158, 1) 0deg, rgba(255, 82, 59, 1) 38.774deg, rgba(234, 250, 59, 1) 126.346deg, rgba(30, 255, 221, 1) 200.769deg, rgba(59, 151, 250, 1) 242.308deg, rgba(148, 59, 250, 1) 323.654deg, rgba(199, 70, 158, 1) 360deg)',
                }}
            />
            {/* Буква A белого цвета */}
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
            >
                <path
                    d="M8.237 16.7729C8.029 16.7729 7.86 16.7252 7.73 16.6299C7.60867 16.5346 7.535 16.4089 7.509 16.2529C7.483 16.0882 7.51333 15.9062 7.6 15.7069L11.032 8.1019C11.1447 7.85057 11.279 7.6729 11.435 7.5689C11.5997 7.45624 11.786 7.3999 11.994 7.3999C12.1933 7.3999 12.371 7.45624 12.527 7.5689C12.6917 7.6729 12.8303 7.85057 12.943 8.1019L16.388 15.7069C16.4833 15.9062 16.518 16.0882 16.492 16.2529C16.466 16.4176 16.3923 16.5476 16.271 16.6429C16.1497 16.7296 15.9893 16.7729 15.79 16.7729C15.5473 16.7729 15.3567 16.7166 15.218 16.6039C15.088 16.4826 14.971 16.3006 14.867 16.0579L14.022 14.0949L14.724 14.5499H9.238L9.94 14.0949L9.108 16.0579C8.99533 16.3092 8.87833 16.4912 8.757 16.6039C8.63567 16.7166 8.46233 16.7729 8.237 16.7729ZM11.968 9.3109L10.148 13.6399L9.81 13.2239H14.152L13.827 13.6399L11.994 9.3109H11.968Z"
                    fill="#FFFFFF"
                />
            </svg>
        </div>
    )
}

/**
 * Стандартная версия иконки палитры (с foreignObject для conic-gradient)
 */
function BackgroundPaletteIconStandard({
    className,
}: BackgroundPaletteIconProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            <g clipPath="url(#paint0_angular_20009425_1664_clip_path)">
                <g transform="matrix(-0.00995996 0 0 -0.00995996 12 12)">
                    <foreignObject
                        x="-1104.42"
                        y="-1104.42"
                        width="2208.84"
                        height="2208.84"
                    >
                        <div
                            style={{
                                background:
                                    'conic-gradient(from 90deg,rgba(199, 70, 158, 1) 0deg,rgba(255, 82, 59, 1) 38.774deg,rgba(234, 250, 59, 1) 126.346deg,rgba(30, 255, 221, 1) 200.769deg,rgba(59, 151, 250, 1) 242.308deg,rgba(148, 59, 250, 1) 323.654deg,rgba(199, 70, 158, 1) 360deg)',
                                height: '100%',
                                width: '100%',
                                opacity: 1,
                            }}
                        />
                    </foreignObject>
                </g>
            </g>
            <rect
                x="2"
                y="2"
                width="20"
                height="20"
                rx="4"
                fill="url(#paint0_angular_20009425_1664_clip_path)"
            />
            <path
                d="M8.237 16.7729C8.029 16.7729 7.86 16.7252 7.73 16.6299C7.60867 16.5346 7.535 16.4089 7.509 16.2529C7.483 16.0882 7.51333 15.9062 7.6 15.7069L11.032 8.1019C11.1447 7.85057 11.279 7.6729 11.435 7.5689C11.5997 7.45624 11.786 7.3999 11.994 7.3999C12.1933 7.3999 12.371 7.45624 12.527 7.5689C12.6917 7.6729 12.8303 7.85057 12.943 8.1019L16.388 15.7069C16.4833 15.9062 16.518 16.0882 16.492 16.2529C16.466 16.4176 16.3923 16.5476 16.271 16.6429C16.1497 16.7296 15.9893 16.7729 15.79 16.7729C15.5473 16.7729 15.3567 16.7166 15.218 16.6039C15.088 16.4826 14.971 16.3006 14.867 16.0579L14.022 14.0949L14.724 14.5499H9.238L9.94 14.0949L9.108 16.0579C8.99533 16.3092 8.87833 16.4912 8.757 16.6039C8.63567 16.7166 8.46233 16.7729 8.237 16.7729ZM11.968 9.3109L10.148 13.6399L9.81 13.2239H14.152L13.827 13.6399L11.994 9.3109H11.968Z"
                fill="white"
            />
            <defs>
                <clipPath id="paint0_angular_20009425_1664_clip_path">
                    <rect x="2" y="2" width="20" height="20" rx="4" />
                </clipPath>
            </defs>
        </svg>
    )
}

/**
 * Иконка палитры для выбора цвета подложки
 * Автоматически выбирает версию в зависимости от браузера
 */
export function BackgroundPaletteIcon({
    className,
}: BackgroundPaletteIconProps) {
    const useWebKit = isWebKit()

    if (useWebKit) {
        return <BackgroundPaletteIconWebKit className={className} />
    }

    return <BackgroundPaletteIconStandard className={className} />
}
